var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("legend", [_vm._v("Assign to a company")]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("div", { staticClass: "toggle-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.multiple,
                    expression: "formData.multiple",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "toggle",
                attrs: {
                  id: "single",
                  name: "mandated",
                  type: "radio",
                  required: "",
                },
                domProps: {
                  value: false,
                  checked: _vm._q(_vm.formData.multiple, false),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.formData, "multiple", false)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "toggle", attrs: { for: "single" } }, [
                _vm._v("Single User"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.multiple,
                    expression: "formData.multiple",
                  },
                  { name: "validate", rawName: "v-validate" },
                ],
                staticClass: "toggle",
                attrs: {
                  id: "multiple",
                  name: "mandated",
                  type: "radio",
                  required: "",
                },
                domProps: {
                  value: true,
                  checked: _vm._q(_vm.formData.multiple, true),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.formData, "multiple", true)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "toggle", attrs: { for: "multiple" } },
                [_vm._v("Multiple Users (CSV)")]
              ),
            ]),
            _vm._v(" "),
            _c("label", { staticClass: "form__label" }, [
              _vm._v(
                "Would you like to create a single user profile or upload multiple users?"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("mandated"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FormControlMember", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              label: "Select a Company",
              placeholder: "Select the company that the user works for...",
              name: "member",
            },
            model: {
              value: _vm.formData.member,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "member", $$v)
              },
              expression: "formData.member",
            },
          }),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form__group form__group--submit" }, [
      _c("button", { staticClass: "btn btn--primary" }, [_vm._v("Continue")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }